import { Asterisk } from 'lucide-react';

export default function Marquee({ items, testId = 'marquee-band' }) {
  const row = (ariaHidden) => (
    <div aria-hidden={ariaHidden} className="flex shrink-0 items-center">
      {items.map((item, i) => (
        <span
          key={i}
          className="flex items-center text-[13px] font-semibold uppercase tracking-[0.3em] text-brand-teal"
        >
          <Asterisk className="mx-6 size-5 shrink-0 text-brand-teal/40" strokeWidth={1.5} />
          {item}
        </span>
      ))}
    </div>
  );
  return (
    <div
      data-testid={testId}
      className="marquee overflow-hidden border-y border-brand-ink/10 bg-brand-parchment py-5"
    >
      <div className="marquee-track flex w-max">
        {row(false)}
        {row(true)}
      </div>
    </div>
  );
}
